import { Link } from 'react-router-dom';
import './Pricing.css';

function Pricing() {
  return (
    <div className="pricing-page">
      {/* Hero Section */}
      <section className="hero-section">
        <div className="hero-content">
          <h1 className="hero-title">Transparent Pricing</h1>
          <p className="hero-subtitle">Choose the plan that fits your business needs. No hidden fees, no surprises.</p>
        </div>
      </section>

      {/* WordPress Hosting & Webmastering Pricing */}
      <section className="services-section">
        <div className="services-container">
          <h2 className="section-title">Managed Hosting & Support</h2>
          <p className="section-subtitle">Complete hosting solutions with full support services for any web application</p>
          
          <div className="pricing-grid">
            <div className="pricing-card">
              <div className="popular-badge">New Business Special</div>
              <h3>Starter</h3>
              <div className="price">$69<span>/month</span></div>
              <p className="plan-description">Perfect for small businesses and personal websites</p>
              <div className="introductory-pricing">
                <p><strong>Special Offer:</strong> $49/month for first 3 months</p>
                <p><em>Then $69/month thereafter</em></p>
              </div>
              <ul className="pricing-features">
                <li>1 web application</li>
                <li>10GB storage</li>
                <li>Basic security updates</li>
                <li>Weekly backups</li>
                <li>Email support</li>
                <li>Application updates</li>
                <li>Basic monitoring</li>
                <li>SSL certificate included</li>
              </ul>
              <Link to="/contact" className="cta-button">Get Started</Link>
            </div>
            
            <div className="pricing-card featured">
              <div className="popular-badge">Most Popular</div>
              <h3>Professional</h3>
              <div className="price">$149<span>/month</span></div>
              <p className="plan-description">Ideal for growing businesses and professional applications</p>
              <ul className="pricing-features">
                <li>Unlimited web applications</li>
                <li>20GB storage</li>
                <li>Premium infrastructure & hosting</li>
                <li>Security updates</li>
                <li>Daily backups</li>
                <li>Priority email support</li>
                <li>Application management</li>
                <li>Performance optimization</li>
                <li>Advanced monitoring & analytics</li>
                <li>SSL certificates</li>
                <li>Uptime monitoring</li>
              </ul>
              <Link to="/contact" className="cta-button">Get Started</Link>
            </div>
          </div>
        </div>
      </section>



      {/* Hourly Rates Section */}
      <section className="services-section">
        <div className="services-container">
          <h2 className="section-title">Custom Development & Services</h2>
          <p className="section-subtitle">All custom work, consultations, and specialized services</p>
          
          <div className="hourly-rate-simple">
            <div className="hourly-rate-card-simple">
              <div className="hourly-price-large">$150<span>/hour</span></div>
              <p className="rate-description-large">One rate for all custom work and services</p>
              <div className="rate-services-grid">
                <div className="service-category">
                  <h4>Development</h4>
                  <p>Custom coding, APIs, databases, integrations</p>
                </div>
                <div className="service-category">
                  <h4>Design & UX</h4>
                  <p>UI/UX design, wireframing, visual design</p>
                </div>
                <div className="service-category">
                  <h4>Consultation</h4>
                  <p>Strategy, planning, architecture, code review</p>
                </div>
                <div className="service-category">
                  <h4>Webmastering</h4>
                  <p>Content management, updates, optimization</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="features-section" id="faq">
        <div className="features-container">
          <h2 className="section-title">Frequently Asked Questions</h2>
          <p className="section-subtitle">Common questions about our pricing and services</p>
          
          <div className="faq-grid">
            <div className="faq-item">
              <h4>Do you offer custom pricing?</h4>
              <p>Yes! We understand that every business has unique needs. Contact us for a custom quote tailored to your specific requirements.</p>
            </div>
            
            <div className="faq-item">
              <h4>Can I change plans later?</h4>
              <p>Absolutely! You can upgrade or downgrade your plan at any time. We'll prorate any changes to your billing cycle.</p>
            </div>
            
            <div className="faq-item">
              <h4>Do you offer discounts for annual payments?</h4>
              <p>Yes! We offer 10% discount for annual payments on all hosting plans.</p>
            </div>
            
            <div className="faq-item">
              <h4>How do I get custom work done?</h4>
              <p>All custom development, design, consultation, and specialized support work is billed at our standard hourly rate of $150/hour. This includes development, design, consultation, webmastering, and maintenance tasks.</p>
            </div>
            
            <div className="faq-item">
              <h4>Is there a money-back guarantee?</h4>
              <p>Yes! We offer a 30-day money-back guarantee on all hosting plans. If you're not satisfied, we'll refund your payment.</p>
            </div>
            
            <div className="faq-item">
              <h4>What happens after the introductory pricing?</h4>
              <p>The Starter plan's introductory pricing of $49/month is valid for the first 3 months. After that, the plan continues at $69/month. This special offer helps new businesses get started while ensuring sustainable pricing for ongoing service.</p>
            </div>
            
            <div className="faq-item">
              <h4>Which plan is best for small businesses?</h4>
              <p>Our Starter plan at $69/month is perfect for small businesses just getting started. For growing businesses that need more resources and features, our Professional plan at $149/month includes unlimited applications, premium infrastructure, priority support, and advanced monitoring. All custom work is billed at our standard hourly rate of $150/hour.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <div className="cta-content">
          <h2>Ready to Get Started?</h2>
          <p>Have questions about our pricing? Need a custom quote? We're here to help you find the perfect solution.</p>
          <Link to="/contact" className="cta-button">Contact Us Today</Link>
        </div>
      </section>
    </div>
  );
}

export default Pricing;
